import { NotFoundTemplate } from './NotFoundTemplate';

export const PageNotFound = () => <NotFoundTemplate title="Page Not Found." />;
